module.exports = "images/teamed_image_06.png";